// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1B_3r","title":"ClientInsurance_title__24l_O","itemText":"ClientInsurance_itemText__1fnOP"};